import { Container } from "@dinahmoe/dmafjs-visual";
import { coreEngine, env } from "@dinahmoe/dmafjs-core";

class HeaderContainer extends Container {
  namespace = "visual:header-container";

  handlers = {
    rootWidth: this.handleRootWidthChange,
    rootHeight: this.handleRootHeightChange
  };

  init(node, event) {
    super.init(node, event);
    node._isOpen = false;
  }

  state(node, config, event) {
    const parts = event.name.split(":");
    const action = parts[parts.length - 1];
    const isOverlay = node.rootWidth < 1000;

    if (action === "open") {
      node._isOpen = true;
      if (!isOverlay && env.motion !== "reduced") {
        coreEngine.update({
          uid: node.uid,
          key: "transform",
          value: { transforms: [{
            property: "size.width",
            valueEnd: node.rootWidth - 500,
            duration: 600,
            easing: "EASE_IN_OUT",
            curve: 30
          }] }
        });
      }
    } else if (action === "close") {
      node._isOpen = false;
      if (!isOverlay && env.motion !== "reduced") {
        coreEngine.update({
          uid: node.uid,
          key: "transform",
          value: { transforms: [{
            property: "size.width",
            valueEnd: node.rootWidth,
            duration: 600,
            easing: "EASE_IN_OUT",
            curve: 30
          }] }
        });
      }
    }
  }

  handleRootWidthChange(node) {
    const isOverlay = node.rootWidth < 1000;
    const newWidth = (node._isOpen && !isOverlay && env.motion !== "reduced") ? node.rootWidth - 500 : node.rootWidth;
    coreEngine.update({ uid: node.uid, key: "size.width", value: newWidth });
  }

  handleRootHeightChange(node) {
    coreEngine.update({ uid: node.uid, key: "size.height", value: node.rootHeight });
  }
}

const headerContainer = new HeaderContainer();
export { headerContainer, HeaderContainer };
